import isPropValid from "@emotion/is-prop-valid";

const shouldForwardProp = (prop, elementToBeCreated) =>
  typeof elementToBeCreated === "string" ? isPropValid(prop) : true;

export default shouldForwardProp;
